import { COLORS } from '@/theme';
import styled from 'styled-components';

export const StyledBadge = styled.div<{ $isOverdue?: boolean; $wrap?: boolean }>`
  display: flex;
  justify-content: ${({ $wrap }) => ($wrap ? 'flex-start' : 'center')};
  align-items: ${({ $wrap }) => ($wrap ? 'flex-start' : 'center')};
  width: ${({ $wrap }) => ($wrap ? '100%' : 'fit-content')};
  max-width: 100%;
  padding: 0.25rem 0.75rem;
  min-height: 1.5rem;
  gap: 0.5rem;
  border-radius: 1.6rem;
  border: 1px solid ${({ $isOverdue }) => ($isOverdue ? '#ff4d4f' : COLORS.BRIGHT_GRAY)};
  background: ${({ $isOverdue }) => ($isOverdue ? '#fff1f0' : COLORS.GRAY)};
`;

export const StyledIndicator = styled.div<{ $color: string; $wrap?: boolean }>`
  flex-shrink: 0;
  margin-top: ${({ $wrap }) => ($wrap ? '0.25rem' : '0')};
  border-radius: 50%;
  height: 0.75rem;
  width: 0.75rem;
  background: ${({ $color }) => $color};
`;

export const StyledText = styled.span<{ $isOverdue?: boolean; $wrap?: boolean }>`
  min-width: 0;
  white-space: ${({ $wrap }) => ($wrap ? 'normal' : 'nowrap')};
  overflow-wrap: ${({ $wrap }) => ($wrap ? 'anywhere' : 'normal')};
  word-break: ${({ $wrap }) => ($wrap ? 'break-word' : 'normal')};
  color: ${({ $isOverdue }) => ($isOverdue ? '#ff4d4f' : 'inherit')};
  font-weight: ${({ $isOverdue }) => ($isOverdue ? 'bold' : 'normal')};
`;

export const StyledAttentionIcon = styled.span<{ $wrap?: boolean }>`
  flex-shrink: 0;
  margin-top: ${({ $wrap }) => ($wrap ? '0.125rem' : '0')};
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 1rem;
    height: 1rem;

    path {
      fill: #ff4d4f;
    }
  }
`;
